module.exports = __webpack_public_path__ + "img/tokyo-sauna.70488599.svg";